export default __webpack_public_path__ + "static/media/closeIcon.92cd95f7.svg";